export const apiRoutes = {
  oAuthLogin: '/oauth/login',
  oAuth: '/oauth/status',
  logout: '/oauth/logout',
  encryptApiKey: '/encrypt',

  // MCP Server routes
  mcpEncrypt: '/encrypt',
  mcpCsvUpload: '/onboarding/upload',

  users: '/users',
  agents: '/agents',
} as const;
